module.exports = __webpack_public_path__ + "static/img/13h.d2714f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/13h.svg
// module id = 4044
// module chunks = 1